export const CLINIC = {
  name: "Abhayam Dental Clinic",
  nameMl: "അഭയം ഡെൻ്റൽ ക്ലിനിക്",
  tagline: "Your Smile is Our Priority",
  phone: "+91 97447 27917",
  phoneRaw: "+919744727917",
  whatsapp: "919744727917",
  address: {
    line1: "Vellarangal",
    line2: "Manjeri",
    state: "Kerala",
    pin: "676121",
    full: "Vellarangal, Manjeri, Kerala 676121",
  },
  rating: 4.3,
  reviewCount: 18,
  hours: {
    weekday: "Monday – Saturday · 9:30 AM – 7:00 PM",
    sunday: "Sunday · Closed",
  },
  mapEmbed:
    "https://maps.google.com/maps?q=Manjeri%2C%20Kerala%20676121&t=&z=14&ie=UTF8&iwloc=&output=embed",
  mapLink: "https://www.google.com/maps/dir/?api=1&destination=Manjeri+Kerala+676121",
};

export const buildWhatsAppLink = (message) =>
  `https://wa.me/${CLINIC.whatsapp}?text=${encodeURIComponent(message)}`;

export const TREATMENTS = [
  "General Consultation",
  "Dental Cleaning",
  "Teeth Whitening",
  "Root Canal Treatment",
  "Dental Fillings",
  "Tooth Extraction",
  "Dental Crowns",
  "Dental Bridges",
  "Dental Implants",
  "Dentures",
  "Braces / Orthodontics",
  "Kids Dentistry",
  "Cosmetic Dentistry",
  "Emergency Dental Care",
];
